import React, { useState, useEffect, useRef } from 'react';
import { adminAxios } from '../../../services/api';

const DashboardFilters = ({
    sourceName,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    setAppliedStartDate,
    setAppliedEndDate,
    minDate,
    maxDate,
    setCurrentPage,
    selectedState,
    setSelectedState,
    selectedDistrict,
    setSelectedDistrict
}) => {
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const startRef = useRef(null);
    const endRef = useRef(null);

    console.log(sourceName, "sourceName")

    useEffect(() => {
        const handleStartChange = (e) => setAppliedStartDate(e.target.value);
        const handleEndChange = (e) => setAppliedEndDate(e.target.value);

        const startNode = startRef.current;
        const endNode = endRef.current;

        if (startNode) startNode.addEventListener('change', handleStartChange);
        if (endNode) endNode.addEventListener('change', handleEndChange);

        return () => {
            if (startNode) startNode.removeEventListener('change', handleStartChange);
            if (endNode) endNode.removeEventListener('change', handleEndChange);
        };
    }, [setAppliedStartDate, setAppliedEndDate]);

    useEffect(() => {
        adminAxios.get(`/lgd/states`)
            .then(res => {
                if (res.data && res.data.success) setStates(res.data.data);
            })
            .catch(err => console.error("Error fetching states:", err));
    }, []);

    useEffect(() => {
        if (selectedState) {
            adminAxios.get(`/lgd/districts/state/${selectedState}`)
                .then(res => {
                    if (res.data && res.data.success) setDistricts(res.data.data);
                })
                .catch(err => console.error("Error fetching districts:", err));
        } else {
            setDistricts([]);
            if (selectedDistrict !== "") {
                setSelectedDistrict("");
            }
        }
    }, [selectedState, selectedDistrict, setSelectedDistrict]);
    return (
        <>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                    <h4 className="fw-bold mb-1" style={{ color: "#0056b3" }}>
                        Dashboard (Source:
                        <img
                            src={sourceName === "U-WIN" ? "/Images/uwin-icon.svg" : sourceName === "JANANI" ? "/Images/janani-icon.svg" : sourceName === "RBSK" ? "/Images/rbsk-icon.svg" : sourceName === "OTHERS" ? "/Images/others-icon.svg" : ""}
                            alt={sourceName}
                            className="mx-2"
                            style={{ width: "30px", height: "30px" }}
                        />
                        {sourceName})
                    </h4>
                </div>
            </div>

            <div className="d-flex align-items-end flex-wrap gap-3 pb-3 border-bottom border-secondary-subtle">
                <div className="d-flex flex-column gap-1">
                    <label className="text-muted text-uppercase fw-bold" style={{ fontSize: 10, letterSpacing: "0.08em" }}>Start Date</label>
                    <input
                        ref={startRef}
                        type="date"
                        className="form-control filter-select"
                        value={startDate}
                        min={minDate}
                        max={maxDate}
                        onChange={(e) => { setStartDate(e.target.value); setCurrentPage(1); }}
                        style={{ height: 38 }}
                    />
                </div>

                <div className="d-flex flex-column gap-1">
                    <label className="text-muted text-uppercase fw-bold" style={{ fontSize: 10, letterSpacing: "0.08em" }}>End Date</label>
                    <input
                        ref={endRef}
                        type="date"
                        className="form-control filter-select"
                        value={endDate}
                        min={startDate}
                        max={maxDate}
                        disabled={!startDate}
                        onChange={(e) => { setEndDate(e.target.value); setCurrentPage(1); }}
                        style={{ height: 38 }}
                    />
                </div>

                <div className="d-flex flex-column gap-1">
                    <label className="text-muted text-uppercase fw-bold" style={{ fontSize: 10, letterSpacing: "0.08em" }}>State</label>
                    <select
                        className="form-control filter-select"
                        value={selectedState}
                        onChange={(e) => {
                            setSelectedState(e.target.value);
                            setSelectedDistrict("");
                            setCurrentPage(1);
                        }}
                        style={{ height: 38, minWidth: 150 }}
                    >
                        <option value="">All States</option>
                        {states.map(s => (
                            <option key={s.id} value={s.state_lgd}>{s.state_name}</option>
                        ))}
                    </select>
                </div>

                <div className="d-flex flex-column gap-1">
                    <label className="text-muted text-uppercase fw-bold" style={{ fontSize: 10, letterSpacing: "0.08em" }}>District</label>
                    <select
                        className="form-control filter-select"
                        value={selectedDistrict}
                        onChange={(e) => {
                            setSelectedDistrict(e.target.value);
                            setCurrentPage(1);
                        }}
                        disabled={!selectedState}
                        style={{ height: 38, minWidth: 150 }}
                    >
                        <option value="">All Districts</option>
                        {districts.map(d => (
                            <option key={d.id} value={d.district_lgd}>{d.district_name}</option>
                        ))}
                    </select>
                </div>

                {(startDate !== "" || endDate !== "" || selectedState !== "" || selectedDistrict !== "") && (
                    <button
                        onClick={() => {
                            setStartDate("");
                            setEndDate("");
                            setAppliedStartDate("");
                            setAppliedEndDate("");
                            setSelectedState("");
                            setSelectedDistrict("");
                            setCurrentPage(1);
                        }}
                        className="btn btn-outline-danger"
                        style={{ height: 38, borderRadius: 12, fontWeight: 600, fontSize: 13 }}
                    >
                        Clear Filters
                    </button>
                )}

                {/* <div className="ms-auto d-flex align-items-center">
                    <button
                        onClick={handleExportCSVFallback}
                        disabled={exportingFormat !== null}
                        className="btn btn-primary"
                        style={{
                            height: 38,
                            borderRadius: 12,
                            minWidth: 120,
                            boxShadow: "0 4px 12px var(--accent-primary-glow)",
                            transition: "all 0.2s ease"
                        }}
                    >
                        {exportingFormat === "csv" ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Exporting...
                            </>
                        ) : (
                            <> Export CSV</>
                        )}
                    </button>
                </div> */}
            </div>
        </>
    );
};

export default DashboardFilters;
